module.exports = __webpack_public_path__ + "img/appborderImage.c8c2e7c1.png";